
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const Role = {
  ADMIN: 'ADMIN',
  EDITOR: 'EDITOR',
  USER: 'USER'
} as const

export type Role = (typeof Role)[keyof typeof Role]


export const ArticleStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED'
} as const

export type ArticleStatus = (typeof ArticleStatus)[keyof typeof ArticleStatus]


export const HomepageSlotType = {
  MAIN_FEATURE: 'MAIN_FEATURE',
  SIDE_RELATED: 'SIDE_RELATED',
  OLD_FEATURE: 'OLD_FEATURE',
  HOT_TOPIC: 'HOT_TOPIC'
} as const

export type HomepageSlotType = (typeof HomepageSlotType)[keyof typeof HomepageSlotType]


export const EditorialVisibilityMode = {
  AUTO: 'AUTO',
  MANUAL: 'MANUAL',
  HYBRID: 'HYBRID',
  DISABLED: 'DISABLED'
} as const

export type EditorialVisibilityMode = (typeof EditorialVisibilityMode)[keyof typeof EditorialVisibilityMode]


export const EditorialSectionType = {
  MANUAL: 'MANUAL',
  AUTO: 'AUTO',
  HYBRID: 'HYBRID'
} as const

export type EditorialSectionType = (typeof EditorialSectionType)[keyof typeof EditorialSectionType]


export const EditorialSectionLayout = {
  LIST: 'LIST',
  GRID: 'GRID',
  FEATURED_GRID: 'FEATURED_GRID',
  STRIP: 'STRIP'
} as const

export type EditorialSectionLayout = (typeof EditorialSectionLayout)[keyof typeof EditorialSectionLayout]


export const CategorySectionType = {
  GENERAL: 'GENERAL',
  LEAGUE: 'LEAGUE',
  TOURNAMENT: 'TOURNAMENT',
  TRANSFER: 'TRANSFER',
  CLUB: 'CLUB',
  SPECIAL: 'SPECIAL',
  INTERNAL: 'INTERNAL'
} as const

export type CategorySectionType = (typeof CategorySectionType)[keyof typeof CategorySectionType]


export const EventHubType = {
  TOURNAMENT: 'TOURNAMENT',
  TRANSFER_WINDOW: 'TRANSFER_WINDOW',
  FINAL: 'FINAL',
  CAMPAIGN: 'CAMPAIGN',
  SPECIAL: 'SPECIAL'
} as const

export type EventHubType = (typeof EventHubType)[keyof typeof EventHubType]


export const EditorialEntityStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  ARCHIVED: 'ARCHIVED'
} as const

export type EditorialEntityStatus = (typeof EditorialEntityStatus)[keyof typeof EditorialEntityStatus]


export const EventHubArticleOverrideMode = {
  INCLUDE: 'INCLUDE',
  EXCLUDE: 'EXCLUDE',
  FEATURED: 'FEATURED'
} as const

export type EventHubArticleOverrideMode = (typeof EventHubArticleOverrideMode)[keyof typeof EventHubArticleOverrideMode]


export const Sport = {
  FOOTBALL: 'FOOTBALL',
  HANDBALL: 'HANDBALL',
  VOLLEYBALL: 'VOLLEYBALL'
} as const

export type Sport = (typeof Sport)[keyof typeof Sport]


export const ForumType = {
  LEAGUE: 'LEAGUE',
  TEAM: 'TEAM',
  GENERAL: 'GENERAL'
} as const

export type ForumType = (typeof ForumType)[keyof typeof ForumType]


export const ForumThreadType = {
  DISCUSSION: 'DISCUSSION',
  MATCH: 'MATCH',
  ARTICLE: 'ARTICLE',
  GENERAL: 'GENERAL',
  TRANSFER: 'TRANSFER',
  FANTASY: 'FANTASY'
} as const

export type ForumThreadType = (typeof ForumThreadType)[keyof typeof ForumThreadType]


export const ForumFlair = {
  MATCH: 'MATCH',
  TRANSFER: 'TRANSFER',
  RANT: 'RANT',
  MEME: 'MEME',
  ANALYSIS: 'ANALYSIS',
  GENERAL: 'GENERAL'
} as const

export type ForumFlair = (typeof ForumFlair)[keyof typeof ForumFlair]


export const ForumReportStatus = {
  OPEN: 'OPEN',
  REVIEWED: 'REVIEWED',
  DISMISSED: 'DISMISSED',
  ACTIONED: 'ACTIONED'
} as const

export type ForumReportStatus = (typeof ForumReportStatus)[keyof typeof ForumReportStatus]


export const ForumThreadStatus = {
  ACTIVE: 'ACTIVE',
  LOCKED: 'LOCKED',
  ARCHIVED: 'ARCHIVED',
  COLD_ARCHIVE: 'COLD_ARCHIVE'
} as const

export type ForumThreadStatus = (typeof ForumThreadStatus)[keyof typeof ForumThreadStatus]


export const ThreadHighlightStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED'
} as const

export type ThreadHighlightStatus = (typeof ThreadHighlightStatus)[keyof typeof ThreadHighlightStatus]


export const FriendshipStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
  BLOCKED: 'BLOCKED'
} as const

export type FriendshipStatus = (typeof FriendshipStatus)[keyof typeof FriendshipStatus]


export const IffOutputType = {
  SRT_ONLY: 'SRT_ONLY',
  MP4_SOFT_SUBTITLE: 'MP4_SOFT_SUBTITLE',
  MP4_BURNED_IN_SUBTITLE: 'MP4_BURNED_IN_SUBTITLE'
} as const

export type IffOutputType = (typeof IffOutputType)[keyof typeof IffOutputType]


export const IffJobStatus = {
  QUEUED: 'QUEUED',
  DOWNLOADING_AUDIO: 'DOWNLOADING_AUDIO',
  TRANSCRIBING: 'TRANSCRIBING',
  TRANSLATING: 'TRANSLATING',
  DOWNLOADING_VIDEO: 'DOWNLOADING_VIDEO',
  MUXING_SUBTITLES: 'MUXING_SUBTITLES',
  BURNING_SUBTITLES: 'BURNING_SUBTITLES',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
} as const

export type IffJobStatus = (typeof IffJobStatus)[keyof typeof IffJobStatus]
